import React, { PureComponent } from 'react';
import { number, node, object } from 'prop-types';
import { VictoryChart } from 'victory';
import { isIE11 } from 'common/utils';

/**
 *
 *
 * @class IEVictoryChart
 * @extends {PureComponent}
 */
class IEVictoryChart extends PureComponent {
  static displayName = 'IEVictoryChart';
  static propTypes = {
    height: number,
    width: number,
    children: node,
    style: object,
  };

  render() {
    if (isIE11()) {
      return (
        <div
          style={{
            position: 'relative',
            height: 0,
            width: '100%',
            padding: 0,
            paddingBottom: `${100 * (this.props.height / this.props.width)}%`,
          }}
        >
          <VictoryChart
            {...this.props}
            style={{
              ...this.props.style,
              parent: {
                position: 'absolute',
                height: '100%',
                width: '100%',
                left: 0,
                top: 0,
              },
            }}
          >
            {this.props.children}
          </VictoryChart>
        </div>
      );
    }

    return <VictoryChart {...this.props}>{this.props.children}</VictoryChart>;
  }
}

export default IEVictoryChart;



// WEBPACK FOOTER //
// ./src/common/IEVictoryChart.js